import Vue from 'vue'
import VueRouter from 'vue-router'
import { MessageBox } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/wechat/callback',
    name: 'WechatCallback',
    component: () => import('@/views/WechatCallback.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('@/views/Courses.vue')
  },
  {
    path: '/course/:id',
    name: 'CourseDetail',
    component: () => import('@/views/CourseDetail.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/supply-chain',
    name: 'SupplyChain',
    component: () => import('@/views/Developing.vue')
  },
  {
    path: '/enterprise',
    name: 'Enterprise',
    component: () => import('@/views/Developing.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    MessageBox.alert('请先登录，解锁精彩课程内容', '温馨提醒', {
      confirmButtonText: '去登录',
      type: 'info',
      customClass: 'login-prompt-dialog',
      callback: () => {
        next({ path: '/login', query: { redirect: to.fullPath } })
      }
    })
    return
  }

  if (to.path === '/login' && token) {
    next(to.query.redirect || '/home')
    return
  }

  if (token && to.meta.requiresAuth && to.path !== '/profile') {
    if (sessionStorage.getItem('profileChecked') === '1' && sessionStorage.getItem('profileComplete') !== '1') {
      next('/profile')
      return
    }
  }

  next()
})

// 捕获路由重定向/导航时 Vue Router 抛出的错误，避免退出登录等场景报错弹窗
function catchRedirectErr(promise) {
  return promise.catch(err => {
    if (err.name === 'NavigationDuplicated' || err.name === 'NavigationAborted' ||
        (err.message && err.message.includes('Redirected'))) {
      return Promise.resolve()
    }
    return Promise.reject(err)
  })
}
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push(location) {
  return catchRedirectErr(originalPush.call(this, location))
}
VueRouter.prototype.replace = function replace(location) {
  return catchRedirectErr(originalReplace.call(this, location))
}

export default router

